<script>
	import LazyImgResponsive from "../../components/LazyImgResponsive.svelte";
	import LinkButton from "../../components/LinkButton.svelte";

	export let id;
	export let section;
	export let slideProgress;
	export let content = {};
</script>

<div class="container">
	<div class="content">
		<div class="t-cta">
			<div class="t-cta-title">{@html content.heading}</div>
			<div class="t-copy-sans">{@html content.text}</div>
		</div>
		<div class="image">
			<LazyImgResponsive id="abo_online" src="{PATH}assets/images/content/{section}_{id}_bild_1.png" />
		</div>
		<LinkButton link={content.button_link} text={content.button_text} color="red" />
	</div>
	<div class="image-d">
		<LazyImgResponsive id="abo_online" src="{PATH}assets/images/content/{section}_{id}_bild_1.png" />
	</div>
</div>

<style lang="scss">
	.container {
		display: flex;
		width: 100%;
		height: 100%;
		align-items: center;
		padding: 120px 0;

		@media (max-width: $breakpoint-tablet) {
			display: block;
			text-align: center;
		}
	}

	.content {
		flex: 0 0 440px;
		margin-right: 0;

		@media (max-width: $breakpoint-tablet) {
			width: 100%;
			max-width: 440px;
			margin: 0 auto;
		}
	}

	.image {
		display: none;

		@media (max-width: $breakpoint-tablet) {
			display: block;
			margin-bottom: -20px;
		}
	}

	.image-d {
		flex: 1 0 1px;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
		top: 10px;

		@media (max-width: $breakpoint-tablet) {
			display: none;
		}
	}

	:global(#abo_online) {
		width: 100%;
	}
</style>
